import Home from '../components/Worker/Home'

let routes = {
    path: '/worker',
    component: resolve => require(['../components/layout/Basic/App'], resolve),
    children: [
      {
          path: '/worker',
          name: 'Home',
          component: Home
      },
    ]
}

export default routes


// WEBPACK FOOTER //
// ./src/router/homeWorker.js